import { VerticalTabsIconItemProps } from '.';

export const requiredProps: VerticalTabsIconItemProps = {};

const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as VerticalTabsIconItemProps,
  },
];

export const testkitTests = [...sharedTests];
export const ssrTests = [...sharedTests];
export const a11yTests = [...sharedTests];
